export default __webpack_public_path__ + "static/graphik-semibold-web-3a950a369280de4e4d5269481c342fce.woff2";